import React from 'react';

import '../../assets/assets-artsdao/css/reset.scss'
import '../../assets/assets-artsdao/css/page.scss'
import '../../assets/assets-artsdao/fonts/Inter/stylesheet.css'

import Whatsapp from './ArtsDaoComponents/Whatsapp';

import Main from './ArtsDaoComponents/Main';
import VipPackage from './ArtsDaoComponents/VipPackage';
import HotelsRecommend from './ArtsDaoComponents/HotelsRecommend';
import Footer from './ArtsDaoComponents/Footer';

export function ArtsDao() {
  return (
    <div className="artsdao wrapper">
      <Whatsapp />
      <Main />
      <VipPackage />
      <HotelsRecommend />
      <Footer />
    </div>
  );
}
